import $ from 'jquery';
//
// // Filter function
//
// function filterElements (filtersParent) {
//
//     var hiddenL = filtersParent.find('.filters-content .filter-box.tag-active').length;
//
//     if (filtersParent.hasClass('filters--horizontal')) {
//         filtersParent.find('.filters-content').fadeOut(function(){
//             filtersParent.find('.filters-content .filter-box.tag-active').slice(0, maxBoxes).removeClass('tag-hidden collapsed').show()
//             filtersParent.find('.filters-content .filter-box.tag-active').slice(maxBoxes, hiddenL).addClass('collapsed').hide()
//             filtersParent.find('.filters-content .filter-box:not(.tag-active)').addClass('tag-hidden').hide()
//             filtersParent.find('.filters-content').fadeIn()
//         })
//     }
// }.
// Filter by filter tag
$('.section--stories-content .filters-nav li a').click(function (e) {
    e.preventDefault();
    var pos = 0, filterList = $(this).parents('.filters-nav-outer').find('.filters-nav'), filterWindow = $(this).parents('.filters-nav-outer').find('.filters-nav-window'), filtersParent = $(this).parents('.filters');
    filterList.find('li').removeClass('active');
    $(this).parent().addClass('active');
    pos = $(this).parent().position().left - 16;
    filterWindow.stop().animate({ scrollLeft: "+=" + pos }, 300);
    // Change select2 value (do not touch the basic select!)
    filtersParent.find('.filter-nav-select option[value="' + $(this).parent().attr('data-filter') + '"]').attr('selected', true);
    filtersParent.find('.filter-nav-select').trigger('change.select2');
    //filterElements(filtersParent)
});
// $('.filter-nav-select').change(function(){
//     var filtersParent = $(this).parents('.filters')
//     filtersParent.find('.filters-nav li[data-filter="'+ $(this).val() +'"] a').click()
// })
